import { ErrorHandler, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class ReviewResponseService {

  constructor(private _http: HttpClient,
              private _errorHandler: ErrorHandler) { }

  /**
   * updates specified contact in api server
   * @param {number} entityId
   * @param {boolean} isAirport
   * @param {number} reviewId
   * @param {string} response
   * @return {Promise<any>}
   */
  putReviewResponse(entityId: number, isAirport: boolean, reviewId: number, response: string): Promise<any> {
    try {
      let URL = '';
      if (response.length < 1) {
        response = null;
      }
      if (isAirport) {
        URL = `${environment.airportsApiUrl}/airports/${entityId}/review/${reviewId}/response`;
      } else {
        URL = `${environment.airportsApiUrl}/businesses/${entityId}/review/${reviewId}/response`;
      }
      const BODY = this._getResponseJSON(response);
      return this._http.put(URL, BODY).toPromise();
    } catch (e) {
      this._errorHandler.handleError(e);
      throw e;
    }
  }

  /**
   * converts business contact to json obj
   * @param {string} response
   * @return {any}
   * @private
   */
  _getResponseJSON (response: string): any {
    return {
      response: response
    };
  }
}
